import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedComponent } from './components/shared/shared.component';
import { SharedRoutingModule } from './shared-routing.module';
import { HeaderComponent } from './components/header/header.component';
import { MenuItemComponent } from './components/sidebar/menu-item/menu-item.component';
import { SubSidebarComponent } from './components/sidebar/sidebar/sub-sidebar.component';
import { FooterComponent } from './components/footer/footer.component';

@NgModule({
  declarations: [
    SharedComponent,
    HeaderComponent,
    MenuItemComponent,
    SubSidebarComponent,
    FooterComponent,
  ],
  imports: [CommonModule, SharedRoutingModule],
  exports: [
    SharedComponent,
    HeaderComponent,
    MenuItemComponent,
    SubSidebarComponent,
    FooterComponent,
  ],
})
export class SharedModule {}
